export const getRateNegotiationToggleSubtitle = (supportArticleUrl: string | undefined) => {
  // Added this tsx file to support learn more anchor which we cannot define in facilityTimeClockSettings.ts
  return (
    <>
      If this is turned on, professionals can propose a new pay rate, giving your workplace a fast
      way to fill more shifts.
      {supportArticleUrl && (
        <>
          {" "}
          <a href={supportArticleUrl} target="_blank">
            Learn more
          </a>
        </>
      )}
    </>
  );
};
